import { AxiosResponse } from "axios"
import { axiosInstance } from "./common"


export enum InsightsKey {
  KYC_DOCS_MANIPULATION = "KYC_DOCS_MANIPULATION",
  CREDIT_BEHAVIOUR = "CREDIT_BEHAVIOUR"
}

export enum CommonJobsStatus {
  SUBMITTED = "SUBMITTED",
  IN_PROGRESS = "IN_PROGRESS", 
  AVAILABLE = "AVAILABLE",
  FAILED = "FAILED"
}

export interface InsightDetails {
  answer: string;
}

export interface Insight {
  insight_key: InsightsKey;
  status: CommonJobsStatus;
  insight_details?: InsightDetails;
}

export interface InsightsResponse {
  insights: Insight[];
}

export interface GenerateInsightsRequest {
  product: string;
  insight_key?: InsightsKey[];
}


const AiInsightsAPI = {
  get: async ({ case_id, insight_keys }: { case_id: string, insight_keys?:InsightsKey[] }) => {
    const response: AxiosResponse<InsightsResponse> = await axiosInstance.get(
      `v1/cases/${case_id}/insights`,
      {
        params: {
          insight_keys: insight_keys
        },
        paramsSerializer: {
            indexes: null
        }
      }
    );
    return response.data;
  },

  generate: async ({ case_id, request }: { case_id: string; request: GenerateInsightsRequest }) => {
    const response: AxiosResponse<InsightsResponse> = await axiosInstance.post(
      `v1/cases/${case_id}/generate-insights`, 
      null,
      {
        params: request,
        paramsSerializer: {
            indexes: null
        }
      }
    );
    return response.data;
  }
};

export default AiInsightsAPI;
